import React, { useState, useEffect } from "react";
import "./EditLocationForm.css"; // Import CSS for styling

const EditLocationForm = ({ location, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    location_name: location.location_name,
    address: location.address,
    status: location.status || ""
  });

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit updated data
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`/api/locations/update-location/${location.location_id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Failed to update location.");
      }

      const updatedLocation = { ...location, ...formData };

      onSave(updatedLocation); // Update parent state & refresh list
      onClose(); // Close modal
    } catch (error) {
      console.error("Error updating location:", error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>✖</button>
        <h3>Edit Location</h3>
        <form onSubmit={handleSubmit}>
          <label>Location Name:</label>
          <input type="text" id='edit-user-firstname' name="location_name" value={formData.location_name} onChange={handleChange} required />

          <label>Address:</label>
          <input type="text" id='edit-user-firstname' name="address" value={formData.address} onChange={handleChange} required />

          <label>Status:</label>
          <input type="text" id='edit-user-firstname' name="status" value={formData.status} onChange={handleChange} required />

          <button type="submit" className="save-button">Save Changes</button>
        </form>
      </div>
    </div>
  );
};

export default EditLocationForm;
